import { render, staticRenderFns } from "./CreateCourseTopicPopup.vue?vue&type=template&id=22c02b50"
import script from "./CreateCourseTopicPopup.vue?vue&type=script&lang=js"
export * from "./CreateCourseTopicPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports